import React, { createContext, useContext, useEffect, useState } from "react";
import useFetch from "../hooks/fetchMSSQL-hook";

const ReportsContext = createContext(null);

export const ReportsProvider = ({ children }) => {
  const { fetchMssqlApi } = useFetch();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  if (process.env.REACT_APP_LOCAL_DB === "true") return;
  if (sessionStorage.getItem("clientId") === "console") return;
  fetchMssqlApi(
    "getReportList",
    { method: "GET", hideNotification: true },
    (res) => {
      setReports(res || []);
      setLoading(false);
    },
    (err) => {
      console.error("Błąd ładowania raportów:", err);
      setReports([]);
      setLoading(false);
    }
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  return (
    <ReportsContext.Provider value={{ reports, loading }}>
      {children}
    </ReportsContext.Provider>
  );
};

export const useReports = () => useContext(ReportsContext);
